/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderTypeService = {
  salesOrderTypes: [],

  async getByName(name) {
    const requestScreenData = {
      url: "api/SalesOrderType",
      filter: `Description eq '${name}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code) {
    const requestScreenData = {
      url: "api/SalesOrderType",
      // top: "1",
      filter: `Code eq '${code}'`,
    };

    var salesOrderType = this.salesOrderTypes.filter((x) => x.Code == code);

    if (salesOrderType.length > 0) {
      return new Promise(async (resolve) => {
        resolve({
          data: {
            value: salesOrderType,
          },
        });
      });
    } else {
      return new Promise(async (resolve, reject) => {
        try {
          var result = await ApiService.oDataGet(requestScreenData);
          if (result.data.value.length > 0)
            this.salesOrderTypes.push(result.data.value[0]);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
    }
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { SalesOrderTypeService };
